<template>
  <b-overlay :show="loading" rounded="sm">
    <div class="container">
      <b-row>
        <b-col>
          <b-card title="جزئیات محتوا">
            <b-form @submit.prevent>
              <b-row>
                <b-col
                    class="mt-2"
                    md="6"
                    offset-md="3"
                >
                  <b-row>
                    <b-col md="12">
                      <b-form-group
                          label="نوع"
                          label-for="Type"
                          class="flex-grow-1 m-0"
                      >
                        <v-select
                            v-model="Form.Type"
                            name="Type"
                            dir="rtl"
                            :reduce="x => x.value"
                            label="text"
                            input-id="Type"
                            :clearable="false"
                            :options="enums('ContentType')"
                            :disabled="editing"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-for="(content, index) in Form.ContentDetails" :key="content.Id" cols="10" offset-md="1" class="mt-2">
                  <b-row>
                    <b-col cols="11">
                      <b-row class="border p-2">
                        <b-col md="4">
                          <upload-media
                              v-model="content.Image"
                              icon="ImageIcon"
                              label="انتخاب عکس"
                              class="mt-2"
                          />
                        </b-col>

                        <b-col md="8">
                          <b-form-group
                              label="عنوان"
                          >
                            <b-form-input
                                v-model="content.Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                          <b-form-group
                              label="لینک"
                          >
                            <b-form-input
                                v-model="content.URL"
                                autocomplete="off"
                            />
                          </b-form-group>

                          <b-form-group
                              label="توضیحات"
                              label-for="Description"
                          >
                            <div class="form-label-group">
                              <b-form-textarea
                                  id="Description"
                                  v-model="content.Description"
                                  name="Description"
                                  autocomplete="off"
                                  rows="3"
                                  no-resize
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="1" class="d-flex flex-column align-items-center justify-content-center">
                      <b-button v-if="deleting === content.Id" class="btn-icon mb-1" size="sm" @click="deleting = null">
                        <feather-icon icon="XIcon" />
                      </b-button>
                      <template v-else>
                        <b-button v-if="content.Id" variant="primary" class="btn-icon mb-1" size="sm" @click="updateContent(content)">
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                        <b-button v-else variant="primary" class="btn-icon mb-1" size="sm" @click="updateContent(content)">
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </template>
                      <b-button v-if="deleting === content.Id" variant="danger" class="btn-icon" size="sm" @click="deleteContent(content.Id, index)">
                        <feather-icon icon="CheckIcon" />
                      </b-button>
                      <b-button v-else variant="danger" class="btn-icon" size="sm" @click="deleting = content.Id">
                        <feather-icon icon="Trash2Icon" />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="!editing && !saved" cols="12" class="mt-1 mb-2 text-center">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                  >
                    ذخیره
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-col>
                <b-col v-else cols="12" class="mt-1 text-center">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addContentDetails"
                  >
                    <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                    />
                    <span>افزودن</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import uploadMedia from "@/tools/media/uploadMedia.vue";

export default {
  name: 'ContentDetails',
  components: { uploadMedia },
  data() {
    return {
      Form: {
        Id: null,
        ContentDetails: [],
        Type: null,
      },
      loading: false,
      contentDetailsRemoveId: null,
      saved: false,
      deleting: null
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    }
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== undefined) this.get()
      }
    }
  },
  methods: {
    get() {
      this.loading = true
      this.$http.post(
        this.$api.content.get, {
          Type: this.editing,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        }).catch(() => {
          this.loading = false
      })
    },
    save() {
      let url = this.$api.content.addDetails
      let data = { Type: this.Form.Type }

      this.loading = true
      this.$http.post(url, data,)
          .then(response => {
            console.log(response)
            this.loading = false
            this.saved = true
          })
          .finally(() => {
            this.loading = false
          })
    },
    addContentDetails() {
      let item = {
        Title: '',
        Description: '',
        Image: null,
        URL: '',
        ContentId: this.Form.Id
      }
      this.Form.ContentDetails.push(item)
    },
    deleteContent(id, index) {
      if (!id) return this.Form.ContentDetails.splice(index, 1)
      this.loading = true
      this.$http.post(
          this.$api.content.removeDetails, { Id: id },
      ).then(() => {
        this.loading = false
        let index = this.Form.ContentDetails.findIndex(i => i.Id === id)
        if (index !== -1) this.Form.ContentDetails.splice(index, 1)
      }).catch(() => {
        this.deleting = null
        this.loading = false
      })
    },
    updateContent(item) {
      if (item.Description === '' || item.Title === '')
        return this.$bvToast.toast('لطفا همه فیلد ها را پر کنید', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
      let url
      this.loading = true
      if (item.Id) url = this.$api.content.updateDetails
      else url = this.$api.content.addDetails
      const formData = new FormData()
      Object.keys(item).forEach(key => {
        formData.append(`${key}`, item[key])
      })
      this.$http.post(url, formData)
          .then(response => {
            this.loading = false
            if (item.ContentId) {
              let index = this.Form.ContentDetails.findIndex(i => i.ContentId === item.ContentId)
              if (index !== -1) {
                this.Form.ContentDetails[index].Id = response.data
                delete this.Form.ContentDetails[index].ContentId
              }
            }
          }).catch(() => {
            this.loading = false
          })
    }
  },
}
</script>
